import { InputWithOptionsDriver } from '../InputWithOptions/InputWithOptions.driver';

export interface SearchDriver extends Omit<InputWithOptionsDriver, 'driver'> {
  driver: InputWithOptionsDriver['driver'] & {
    isExpandable: () => boolean;
    isCollapsed: () => boolean;
  };
}
